export default class {
    constructor (ScormResource) {
        this.ScormResource = ScormResource;
        this.setScormFiles();
    }

    $onInit () {
        this.scormFiles = [];
    }

    setScormFiles () {
        this.ScormResource.query({}).$promise.then(result => {
            this.scormFiles = result;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/coursyScorm/index.js